export default __webpack_public_path__ + "static/media/front.36eb2866.svg";